import React, { useState } from 'react';
import { CheckSquare, Calendar, Clock, Users, ChevronRight, AlertCircle, PaperclipIcon, X, FileText } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
export function EditTask() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  // Mock task data - in a real app, this would be fetched from an API
  const task = {
    id: 1,
    title: 'مراجعة التقارير المالية للربع الثالث',
    description: 'مراجعة وتحليل التقارير المالية للربع الثالث، وتحديد أي تناughtات، وإعداد ملخص لاجتماع اللجنة.',
    committee: 'لجنة المالية',
    assignedTo: 'محمد الهاشمي',
    createdBy: 'أحمد علي',
    createdDate: '2023-08-30',
    deadline: '2023-09-15',
    status: 'completed',
    priority: 'high',
    progress: 100,
    attachments: [{
      id: 1,
      name: 'التقرير_المالي_الربع_الثالث.xlsx',
      size: '2.4 ميجابايت',
      type: 'XLSX'
    }, {
      id: 2,
      name: 'إرشادات_التحليل.pdf',
      size: '1.8 ميجابايت',
      type: 'PDF'
    }]
  };
  const [attachments, setAttachments] = useState(task.attachments);
  const [selectedCommittee, setSelectedCommittee] = useState(task.committee);
  const [selectedAssignee, setSelectedAssignee] = useState(task.assignedTo);
  const [status, setStatus] = useState(task.status);
  const [priority, setPriority] = useState(task.priority);
  const [title, setTitle] = useState(task.title);
  const [description, setDescription] = useState(task.description);
  const [deadline, setDeadline] = useState(task.deadline);
  const [progress, setProgress] = useState(task.progress);
  const committees = [{
    id: 1,
    name: 'لجنة المالية'
  }, {
    id: 2,
    name: 'لجنة الموارد البشرية'
  }, {
    id: 3,
    name: 'لجنة تقنية المعلومات'
  }, {
    id: 4,
    name: 'لجنة المشتريات'
  }, {
    id: 5,
    name: 'لجنة ضمان الجودة'
  }];
  const members = [{
    id: 1,
    name: 'محمد الهاشمي',
    committee: 'لجنة المالية'
  }, {
    id: 2,
    name: 'عائشة المنصوري',
    committee: 'لجنة الموارد البشرية'
  }, {
    id: 3,
    name: 'عمر الشامسي',
    committee: 'لجنة تقنية المعلومات'
  }, {
    id: 4,
    name: 'فاطمة الزعابي',
    committee: 'لجنة المشتريات'
  }, {
    id: 5,
    name: 'أحمد الظاهري',
    committee: 'لجنة ضمان الجودة'
  }];
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      if (file) {
        // Convert file size to KB or MB
        const size = file.size > 1024 * 1024 ? `${(file.size / (1024 * 1024)).toFixed(2)} ميجابايت` : `${(file.size / 1024).toFixed(2)} كيلوبايت`;
        setAttachments([...attachments, {
          id: attachments.length + 1,
          name: file.name,
          size,
          type: file.name.split('.').pop()?.toUpperCase() || 'FILE'
        }]);
      }
    }
  };
  const removeAttachment = (id: number) => {
    setAttachments(attachments.filter(attachment => attachment.id !== id));
  };
  const filteredMembers = selectedCommittee ? members.filter(member => member.committee === selectedCommittee) : members;
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'PDF':
        return <FileText size={16} className="text-red-500" data-id="element-1974" />;
      case 'DOCX':
        return <FileText size={16} className="text-blue-500" data-id="element-1975" />;
      case 'XLSX':
        return <FileText size={16} className="text-green-500" data-id="element-1976" />;
      case 'PPTX':
        return <FileText size={16} className="text-orange-500" data-id="element-1977" />;
      default:
        return <FileText size={16} className="text-gray-500" data-id="element-1978" />;
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission - in a real app, this would send data to an API
    console.log({
      id,
      title,
      description,
      committee: selectedCommittee,
      assignedTo: selectedAssignee,
      deadline,
      status,
      priority,
      progress,
      attachments
    });
    // Redirect to task detail page
    window.location.href = `/tasks/${id}`;
  };
  return <div dir="rtl" data-id="element-1979">
      <div className="flex items-center mb-6" data-id="element-1980">
        <Link to={`/tasks/${id}`} className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-1981">
          <ChevronRight size={20} className="ml-1" data-id="element-1982" />
          العودة إلى المهمة
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-1983">تعديل المهمة</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1984">
        <form onSubmit={handleSubmit} data-id="element-1985">
          <div className="space-y-6" data-id="element-1986">
            {/* Task Title */}
            <div data-id="element-1987">
              <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1988">
                عنوان المهمة <span className="text-red-500" data-id="element-1989">*</span>
              </label>
              <input type="text" id="title" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={title} onChange={e => setTitle(e.target.value)} required data-id="element-1990" />
            </div>
            {/* Task Description */}
            <div data-id="element-1991">
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1992">
                الوصف <span className="text-red-500" data-id="element-1993">*</span>
              </label>
              <textarea id="description" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={description} onChange={e => setDescription(e.target.value)} required data-id="element-1994"></textarea>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1995">
              {/* Committee */}
              <div data-id="element-1996">
                <label htmlFor="committee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1997">
                  اللجنة <span className="text-red-500" data-id="element-1998">*</span>
                </label>
                <div className="relative" data-id="element-1999">
                  <select id="committee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" value={selectedCommittee} onChange={e => setSelectedCommittee(e.target.value)} required data-id="element-2000">
                    <option value="" data-id="element-2001">اختر اللجنة</option>
                    {committees.map(committee => <option key={committee.id} value={committee.name} data-id="element-2002">
                        {committee.name}
                      </option>)}
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2003">
                    <Users size={18} className="text-gray-400" data-id="element-2004" />
                  </div>
                </div>
              </div>
              {/* Assigned To */}
              <div data-id="element-2005">
                <label htmlFor="assignee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2006">
                  تعيين إلى <span className="text-red-500" data-id="element-2007">*</span>
                </label>
                <div className="relative" data-id="element-2008">
                  <select id="assignee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" value={selectedAssignee} onChange={e => setSelectedAssignee(e.target.value)} required data-id="element-2009">
                    <option value="" data-id="element-2010">اختر المكلف</option>
                    {filteredMembers.map(member => <option key={member.id} value={member.name} data-id="element-2011">
                        {member.name}
                      </option>)}
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2012">
                    <Users size={18} className="text-gray-400" data-id="element-2013" />
                  </div>
                </div>
              </div>
              {/* Deadline */}
              <div data-id="element-2014">
                <label htmlFor="deadline" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2015">
                  تاريخ الاستحقاق <span className="text-red-500" data-id="element-2016">*</span>
                </label>
                <div className="relative" data-id="element-2017">
                  <input type="date" id="deadline" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={deadline} onChange={e => setDeadline(e.target.value)} required data-id="element-2018" />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2019">
                    <Calendar size={18} className="text-gray-400" data-id="element-2020" />
                  </div>
                </div>
              </div>
              {/* Priority */}
              <div data-id="element-2021">
                <label htmlFor="priority" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2022">
                  الأولوية <span className="text-red-500" data-id="element-2023">*</span>
                </label>
                <div className="relative" data-id="element-2024">
                  <select id="priority" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" value={priority} onChange={e => setPriority(e.target.value)} required data-id="element-2025">
                    <option value="" data-id="element-2026">اختر الأولوية</option>
                    <option value="high" data-id="element-2027">عالية</option>
                    <option value="medium" data-id="element-2028">متوسطة</option>
                    <option value="low" data-id="element-2029">منخفضة</option>
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2030">
                    <AlertCircle size={18} className="text-gray-400" data-id="element-2031" />
                  </div>
                </div>
              </div>
              {/* Status */}
              <div data-id="element-2032">
                <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2033">
                  الحالة <span className="text-red-500" data-id="element-2034">*</span>
                </label>
                <div className="relative" data-id="element-2035">
                  <select id="status" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 appearance-none" value={status} onChange={e => setStatus(e.target.value)} required data-id="element-2036">
                    <option value="" data-id="element-2037">اختر الحالة</option>
                    <option value="pending" data-id="element-2038">معلقة</option>
                    <option value="completed" data-id="element-2039">مكتملة</option>
                    <option value="delayed" data-id="element-2040">متأخرة</option>
                  </select>
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-2041">
                    <CheckSquare size={18} className="text-gray-400" data-id="element-2042" />
                  </div>
                </div>
              </div>
              {/* Progress */}
              <div data-id="element-2043">
                <label htmlFor="progress" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2044">
                  نسبة الإنجاز (%)
                </label>
                <input type="number" id="progress" min="0" max="100" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={progress} onChange={e => setProgress(Number(e.target.value))} data-id="element-2045" />
                <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2" data-id="element-2046">
                  <div className="h-2.5 rounded-full bg-orange-500" style={{
                  width: `${progress}%`
                }} data-id="element-2047"></div>
                </div>
              </div>
            </div>
            {/* Attachments */}
            <div data-id="element-2048">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2049">
                المرفقات
              </label>
              {/* Existing Attachments */}
              {attachments.length > 0 && <div className="mb-4 space-y-2" data-id="element-2050">
                  <h4 className="text-sm font-medium text-gray-700" data-id="element-2051">
                    الملفات الحالية
                  </h4>
                  {attachments.map(file => <div key={file.id} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg" data-id="element-2052">
                      <div className="flex items-center" data-id="element-2053">
                        {getFileIcon(file.type)}
                        <span className="mr-2 text-sm font-medium" data-id="element-2054">
                          {file.name}
                        </span>
                        <span className="mr-2 text-xs text-gray-500" data-id="element-2055">
                          {file.size}
                        </span>
                      </div>
                      <button type="button" onClick={() => removeAttachment(file.id)} className="text-gray-400 hover:text-red-500" data-id="element-2056">
                        <X size={16} data-id="element-2057" />
                      </button>
                    </div>)}
                </div>}
              {/* Upload New Attachments */}
              <div className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center" data-id="element-2058">
                <div className="mb-3" data-id="element-2059">
                  <PaperclipIcon size={24} className="mx-auto text-gray-400" data-id="element-2060" />
                </div>
                <p className="text-sm text-gray-500 mb-2" data-id="element-2061">
                  اسحب وأفلت الملفات هنا، أو انقر للتصفح
                </p>
                <p className="text-xs text-gray-400 mb-3" data-id="element-2062">
                  الصيغ المدعومة: PDF، DOCX، XLSX، PPTX (الحد الأقصى 10
                  ميجابايت)
                </p>
                <input type="file" id="file-upload" className="hidden" onChange={handleFileUpload} data-id="element-2063" />
                <label htmlFor="file-upload" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors cursor-pointer" data-id="element-2064">
                  تصفح الملفات
                </label>
              </div>
            </div>
            {/* Submit Buttons */}
            <div className="flex justify-end space-x-3 pt-4" data-id="element-2065">
              <Link to={`/tasks/${id}`} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors mr-3" data-id="element-2066">
                إلغاء
              </Link>
              <button type="submit" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-2067">
                <CheckSquare size={18} className="inline ml-2" data-id="element-2068" />
                حفظ التغييرات
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
}